import { queryOptions, useQuery } from "@tanstack/react-query";
import { orpc } from "@/orpc/client";

/** Query options for the unscramble result — exported for SSR loader prefetch. */
export const unscrambleQueryOptions = (letters: string) =>
  queryOptions({
    queryKey: ["unscramble", letters] as const,
    queryFn: () => orpc.unscramble.call({ letters }),
    staleTime: 1000 * 60 * 60, // results are deterministic
  });

export function useUnscramble(letters: string) {
  return useQuery(unscrambleQueryOptions(letters));
}
